

export const templateData = [
    {
        "County Name": "Albany",
        "state": "New York",
        "percentage": 4,
        "state_tax_percentage": 4,
        "zip": ""
    },
    {
        "County Name": "",
        "state": "",
        "percentage": "",
        "state_tax_percentage": "",
        "zip": 12201
    },
    {
        "County Name": "",
        "state": "",
        "percentage": "",
        "state_tax_percentage": "",
        "zip": 12202
    },
    {
        "County Name": "",
        "state": "",
        "percentage": "",
        "state_tax_percentage": "",
        "zip": 12203
    },
    {
        "County Name": "Nassau",
        "state": "New York",
        "percentage": 4.25,
        "state_tax_percentage": 4,
        "zip": ""
    },
    {
        "County Name": "",
        "state": "",
        "percentage": "",
        "state_tax_percentage": "",
        "zip": 11501
    },
    {
        "County Name": "",
        "state": "",
        "percentage": "",
        "state_tax_percentage": "",
        "zip": 11502
    }
];